interface countryData {
  candidatesMatchedQuantity: number;
  countryISOAlpha2Code: string;
  name: string;
}

interface moverAndShaker {
  duns: string;
  mostSnrPrincipal: string;
  primaryName: string;
  primaryNameForUrl: string;
}

interface TopCompany {
  countryName: string;
  duns: string;
  primaryName: string;
  primaryNameForUrl: string;
  yearlyRevenue: number;
}

export interface industryAnalysisResponseData {
  urlSelector: string;
  topCompanies: TopCompany[];
  naics2_selector: string;
  naics2_title: string;
  naics3_selector: string;
  naics3_title: string;
  naics6: number[];
  naicsCodes: number[];
  title: string;
  moversAndShakers: moverAndShaker[];
  geographicSegmentation: string;
  countryCrawl: countryData[];
  description: string;
  activities: string;
}

const isMobile = window.matchMedia(
  "only screen and (max-width: 767px)"
).matches;

export const options = {
  backgroundColor: "#f7f7f7",
  chartArea: {
    height: isMobile ? "75%" : "100%",
    left: 10,
    top: 0,
    width: isMobile ? "90%" : "100%",
  },
  colors: ["#6694ab", "#3bc3db", "#064767", "#11889c"],
  height: isMobile ? 430 : 330,
  legend: {
    position: "bottom",
    textStyle: {
      fontName: "Avenir LT W05_55 Roman",
    },
  },
  pieHole: 0.6,
  pieSliceBorderColor: "transparent",
  tooltip: {
    text: "percentage",
  },
  width: isMobile ? 280 : 520,
};

export interface AdPropertiesParameter {
  "adDivId": string;
  "adHeight": string;
  "adUnitPath": string;
  "adWidth": string;
}

export interface AdPropertiesExtraParameter {
  "lazyLoadAd": boolean;
  "spacingBottom"?: string;
  "spacingTop"?: string;
}

export interface AdComponentParameter {
  "adData": AdPropertiesParameter[];
  "properties": AdPropertiesExtraParameter;
}

export interface IsectionList {
  aTitle?: string;
  anchorId?: string;
}

export interface ProperTiesInterface {
  activitiesTitle: string;
  altListTitle: string;
  descriptionTitle: string;
  profileList: string[];
  viewFewerActivitiesLabel: string;
  viewXActivitiesLabel: string;
}

export interface IAdTab {
  ad: string[] | string;
  lazyLoadAd: boolean;
  spacingBottom: string;
  spacingTop: string;
}

export interface IIndustryProperties {
  activities: string[];
  description: string;
}

export interface IndustryProfileParameter {
  "industryProperties": IIndustryProperties;
  "properties": ProperTiesInterface;
  "tab1": IAdTab;
  "tab2": IAdTab;
  "tab3": IAdTab;
  "tab4": IAdTab;
}

export interface AdProperties {
  adComponentParameter: AdComponentParameter | undefined;
}

export const industryProfileParameter = {
  tab1: {
    "spacingBottom": "23",
    "ad": "{\"adUnitPath\":\"/22150725263/300x250DirectoryIndustryAnalysis1\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1647878487428-0\"}",
    "spacingTop": "12",
    "lazyLoadAd": true
  },
  tab2: {
    "ad": "{\"adUnitPath\":\"/22150725263/300x250DirectoryIndustryAnalysis2\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1647878509569-0\"}",
    "lazyLoadAd": true
  },
  tab3: {
    "ad": "{\"adUnitPath\":\"/22150725263/300x100BusinessDirectoryIndustryAnalysisMobile1\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1653571561493-0\"}",
    "spacingTop": "24",
    "lazyLoadAd": true
  },
  tab4: {
    "ad": "{\"adUnitPath\":\"/22150725263/300x100BusinessDirectoryIndustryAnalysisMobile2\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1653571594993-0\"}",
    "spacingTop": "24",
    "lazyLoadAd": true
  }
}
